import { render } from "./DayMenuCard.vue?vue&type=template&id=38855726&scoped=true"
import script from "./DayMenuCard.vue?vue&type=script&lang=js"
export * from "./DayMenuCard.vue?vue&type=script&lang=js"

import "./DayMenuCard.vue?vue&type=style&index=0&id=38855726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38855726"]])

export default __exports__